import React, {useEffect} from "react";
import Footer from '../user/components/footer';
import Header from "../user/components/header";

const ShippingIndia = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }, []);

    return (
        <>
            <Header />
            <div className="sec_latestpd" style={{ marginTop: "150px" }}>
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <h2 className="sec_title">SHIPPING IN INDIA</h2>
                            <hr />
                        </div>
                        <div className="col-md-12">
                            <p>We offer free shipping for both rolled and framed artworks all over India. We work with reputed domestic courier partners for our domestic deliveries. We deliver to almost 99.2% Pincode locations in India. Some Pincode locations which may be considered as remote by our domestic courier partner may attract special delivery charges. Our customer care will connect to you in this case once the order is placed or you may write to know more quoting your location address/Pincode at care@indigalleria.com</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default ShippingIndia;